import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import "./NextList.scss";
import mockupData from "../../database-mockup.json";

function NextList({ category, current }) {
  const post = mockupData.postData;
  const [nextList, setNextList] = useState("");
  const getText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent;
  };

  const foundPosts = [];
  post.find((postItem) => {
    if (postItem.id !== current && postItem.category === category) {
      foundPosts.push(postItem);
    }
    // Continue checking other elements
    return false; // Returning false ensures find continues iterating
  });

  if (foundPosts.length > 0) {
    console.log("found", foundPosts);
  } else {
    console.log("working");
  }

  return (
    <div className="next">
      <h1 className="next__section">Other posts you may like</h1>
      {foundPosts.slice(0, 3).map((post) => (
        <div className="next__article" key={post.id}>
          <Link className="home__content__list__link" to={`/posts/${post.id}`}>
            <img
              className="next__article__img"
              src={`../upload/${post.imgURL}`}
              alt={post?.img}
            />
          </Link>
          <h2 className="next__article__title">{post.title}</h2>
          <p>{getText(post.content)}</p>
          <Link className="home__content__list__link" to={`/posts/${post.id}`}>
            <button className="next__article__btn btns">Read More</button>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default NextList;
